$ {
  const filters = input?.filterGroup || [];
  const tabName = input?.tabName;
  const noResultsMessage = input?.noListingsMessage;
}

<div>
  <div class="str-filters">
    <for|filter| of=filters>
      <str-filters-button ...filter tabName=tabName />
    </for>
  </div>
  <if(noResultsMessage)>
    <div class="str-filters-message">
      <str-textual-display ...noResultsMessage />
    </div>
  </if>
</div>
